import PropTypes from 'prop-types';

export const Shipment = {
  id: PropTypes.number,
  customerId: PropTypes.string,
  shipDate: PropTypes.string,
  asp: PropTypes.string,
  packingSlipNumber: PropTypes.string,
  trailer: PropTypes.string,
  carrier: PropTypes.string,
  carrierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  expedited: PropTypes.string,
  status: PropTypes.string,
  poNumber: PropTypes.string,
  shipTo: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  note: PropTypes.string,
};

export const ShippingDocuments = {
  id: PropTypes.number,
  fileCategoryId: PropTypes.number,
  fileCategory: PropTypes.string,
  filePath: PropTypes.string,
  fileName: PropTypes.string,
};
